import React from 'react';
import { LandingPageTemplate } from './LandingPageTemplate';

export const ShoeBrandPage: React.FC = () => {
  return <LandingPageTemplate contentKey="shoeBrand" />;
};